// ViewBannerModal.tsx

import React from "react";
import { Modal, TextInput, NumberInput, Text, Textarea } from "@mantine/core";
import { IconPhoto } from "@tabler/icons-react";
import classes from "./view.module.css"; // Use appropriate styles
import { RowDataMerchandise } from "./types";

interface ViewMerchandiseModalProps {
  isOpen: boolean;
  onClose: () => void;
  merchandiseData: RowDataMerchandise;
}

const ViewMerchandiseModal: React.FC<ViewMerchandiseModalProps> = ({
  isOpen,
  onClose,
  merchandiseData,
}) => {
  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          View Merchandise{" "}
        </div>
      }
      opened={isOpen}
      onClose={onClose}
    >
        <Text className={classes.Text}>
        Image <span className={classes.format}>(.jpg, .png)</span>
      </Text>
      <div className={classes.merchandiseImageContainer}>
        {merchandiseData.imageSrc ? (
          <img
            src={merchandiseData.imageSrc}
            alt="Merchandise Image"
            className={classes.merchandiseImageSize}
          />
        ) : (
          <p>
            <IconPhoto />
          </p>
        )}
      </div>

      <TextInput
        label="Merchandise Name:"
        mb="sm"
        value={merchandiseData.merchandiseName}
        readOnly
      />
      <TextInput
        label="Merchandise Model:"
        mb="sm"
        value={merchandiseData.merchandiseModel}
        readOnly
      />

        <Textarea
        label="Merchandise Description"
        placeholder="Merchandise Description"
        mb="sm"
        autosize={true}
        minRows={4}
        value={merchandiseData.merchandiseDesc}
        readOnly
      />

      <NumberInput
        label="Quantity:"
        mb="sm"
        value={merchandiseData.quantity}
        readOnly
      />
      <NumberInput
        label="Cost:"
        mb="sm"
        value={merchandiseData.cost}
        readOnly
      />

      {/* <Group className={classes.buttonBottom}>
        <Button onClick={onClose} className={classes.buttonClose}>
          Close
        </Button>
      </Group> */}
    </Modal>
  );
};

export default ViewMerchandiseModal;
